import styled from 'styled-components';
import sizes from 'utils/screenSizes';
import { font as fontGlobal } from 'styles';

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media all and (max-width: ${sizes.notebook}) {
    margin-top: 80px;
  }
`;

export const Title = styled.h3`
  color: rgb(255, 116, 0);
  font-style: bold;
  font-family: ${fontGlobal.family.ChickenHeadline};
  font-weight: ${fontGlobal.weight.bold};
  font-size: 24px;
  text-align: center;
`;

export const ContainerList = styled.div`
  width: 100%;
  max-width: 700px;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  gap: 60px;
  flex-wrap: wrap;
`;

export const ItemList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 200px;

  h3 {
    font-style: bold;
    font-family: ${fontGlobal.family.ChickenHeadline};
    font-weight: ${fontGlobal.weight.bold};
    color: rgba(0, 0, 0, 0.7);
  }

  h5 {
    font-family: ${fontGlobal.family.ChickenText};
    font-size: ${fontGlobal.sizes.textMedium};
    color: rgba(0, 0, 0, 0.4);
    font-weight: 400;
  }
`;

export const Delivery = styled.div`
  width: 80px;
  margin-top: 5px;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00b2a9;
  border-radius: 8px;

  h5 {
    font-family: ${fontGlobal.family.ChickenText};
    font-size: ${fontGlobal.sizes.textMedium};
    color: #fff;
    font-weight: 400;
  }
`;
